<form-layout [showSave]="false" (onSave)="onSaveClick()" (onBack)="onBackClick()" (onNext)="onSaveAndNextClick()">
  <div>
    <kendo-grid [data]="gridView" (remove)="removeHandler($event)" (edit)="editHandler($event)" [sort]="sort"
      [sortable]="true">
      <kendo-grid-column title="{{'kooperationspartner.salutation' | translate}}" field="anredeId" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem?.anredeId != null">
            <span>
              {{ getAnredeName(dataItem?.anredeId) }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'kooperationspartner.preAcademicTitle' | translate}}" field="praefixTitelId" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem?.praefixTitelId != null">
            <span>
              {{ getPraefixName(dataItem?.praefixTitelId) }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'kooperationspartner.firstname' | translate}}" field="firstname" [width]="100" editor="date">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem?.firstname != null">
            <span>
              {{ dataItem?.firstname }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'kooperationspartner.lastname' | translate}}" field="lastname" [width]="120" editor="date">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem?.lastname != null">
            <span>
              {{ dataItem?.lastname }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="{{'kooperationspartner.emailAddress' | translate}}" field="emailAddress" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem?.emailAddress != null ">
            <span>
              {{ dataItem.emailAddress }}
            </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column [width]="155" *ngIf="!kooperationspartnerForm.disabled">
        <ng-template kendoGridCellTemplate let-isNew="isNew" let-rowIndex="rowIndex">
          <button kendoGridEditCommand [title]="'kooperationspartner.dialog.titleEdit' | translate"
            class="xfound-button-primary">
            <i class="fa fa-pen"></i>
          </button>
          <button kendoGridRemoveCommand [title]="'kooperationspartner.dialog.titleDelete' | translate"
            class="xfound-button-secondary">
            <i class="fa fa-trash"></i>
          </button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>

  <div>
    <button kendoButton class="xfound-button-primary mt-4" (click)="createHandler()"
      *ngIf="!kooperationspartnerForm.disabled && !isFormOpen">
      <span translate>kooperationspartner.grid.add</span>
      <i class="fa fa-plus" style="margin-left: 0.5rem;"></i>
    </button>
  </div>

  <form [formGroup]="kooperationspartnerForm" *ngIf="isFormOpen">
    <div class="form-content">
      <div class="left">
        <kendo-formfield>
          <kendo-label class="form-label" [for]="anrede" text="{{'kooperationspartner.salutation' | translate}} *"
            [infotooltip]="'kooperationspartner.anrede'"></kendo-label>
          <kendo-combobox formControlName="anredeId" #anrede [valuePrimitive]="true" [allowCustom]="false"
            [data]="anredeItems" [valueField]="'anredeId'" [textField]="'name'"
            [appinfotext]="'kooperationspartner.anrede'" kendoDropDownFilter (valueChange)="loadAnreden()">
          </kendo-combobox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label class="form-label" [for]="firstname" text="{{'kooperationspartner.firstname' | translate}} *"
            [infotooltip]="'kooperationspartner.vorname'"></kendo-label>
          <kendo-textbox #firstname formControlName="firstname" showSuccessIcon="initial" showErrorIcon="initial"
            [appinfotext]="'kooperationspartner.vorname'" preventEmptyFormatter [maxlength]=90>
          </kendo-textbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label class="form-label" [for]="lastname" text="{{'kooperationspartner.lastname' | translate}} *"
            [infotooltip]="'kooperationspartner.nachname'"></kendo-label>
          <kendo-textbox #lastname formControlName="lastname" showSuccessIcon="initial" showErrorIcon="initial"
            [appinfotext]="'kooperationspartner.nachname'" preventEmptyFormatter [maxlength]=90>
          </kendo-textbox>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label class="form-label" [for]="praefixtitel" text="{{'kooperationspartner.preAcademicTitle' | translate }}"
            [infotooltip]="'kooperationspartner.akademischertitel'"></kendo-label>
          <kendo-combobox formControlName="praefixTitelId" [valuePrimitive]="true" #praefixtitel [allowCustom]="false"
            [data]="praefixTitelItems" [valueField]="'titelId'" [textField]="'name'"
            [appinfotext]="'kooperationspartner.akademischertitel'" kendoDropDownFilter>
          </kendo-combobox>
        </kendo-formfield>
      </div>
      <div class="right">
        <kendo-formfield>
          <kendo-label class="form-label" [for]="email" text="{{'kooperationspartner.emailAddress' | translate}} *"
            [infotooltip]="'kooperationspartner.emailadresse'"></kendo-label>
          <kendo-textbox #email formControlName="emailAddress" showSuccessIcon="initial" showErrorIcon="initial"
            [appinfotext]="'kooperationspartner.emailadresse'" preventEmptyFormatter [maxlength]=100></kendo-textbox>
          <kendo-formerror *ngIf="emailErrorMessage">{{emailErrorMessage}}</kendo-formerror>
        </kendo-formfield>
      </div>
    </div>
    <div class="grid grid-cols-12 md:gap-x-4 gap-y-4 mt-4">
      <button kendoButton class="xfound-button-secondary col-span-12 md:col-span-6 xl:col-span-3" (click)="cancelForm()">
        {{"schedule-data.dialog.cancel" | translate}}
      </button>
      <button kendoButton class="xfound-button-primary col-span-12 md:col-span-6 xl:col-span-3" (click)="saveKooperationspartner()"
        [disabled]="!kooperationspartnerForm.valid">
        {{"question.save" | translate}}
      </button>
    </div>
  </form>
</form-layout>